import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';




export const infoBarStyles = makeStyles((theme) => ({
    infoBarWrapper: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),

        borderBottom: `1px solid ${tcsmColors.greyFive}`,

        [theme.breakpoints.down('md')]: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
        },

        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
        },
        '& .infobar': {
            '&-inner': {
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1),
                [theme.breakpoints.up('sm')]: {
                    display: 'flex',
                    justifyContent: 'space-between',
                },
            },
            '&-nav': {
                
                [theme.breakpoints.down('xs')]: {
                    marginTop: theme.spacing(1),
                },

                [theme.breakpoints.up('md')]: {
                    width: 'calc(100% / 3)',
                },
                
            },
        },
        '& .breadcrumbs': {
            '&-inner': {
                paddingTop: theme.spacing(2),
                paddingBottom: theme.spacing(2),
                color: tcsmColors.greyTwo,
                [theme.breakpoints.down('sm')]: {
                    paddingTop: theme.spacing(1.5),
                    paddingBottom: theme.spacing(1.5),
                },
                [theme.breakpoints.down('sm')]: {
                    paddingTop: theme.spacing(1),
                    paddingBottom: theme.spacing(1),
                },
            },
            '&-separator': {
                display: 'inline-block',
                marginLeft: theme.spacing(.25),
                marginRight: theme.spacing(.25),
            },
        },
    },



}));



